import { call, put, select } from 'typed-redux-saga';
import { ActionType, createAction } from 'typesafe-actions';
import { DialogResult } from '../types';
import { DialogElem, DialogsHandler } from './types';
import { currentDialogSelector } from './util';

// we want the closeDialog to trigger the onResolve function of the DialogElem
// however, this is a side effect, so should be triggered by the saga, rather
//    than the reducer.
// Sagas run after the reducer, and the reducer will remove the dialogElem,
//    which means the saga won't be access the dialogElem to grab the onResolve.
// Therefore, we split the close action into two - close & after-close.
//    The reducer runs for after-close, while the saga watches close,
//    resulting in the saga running before the reducer.

type CloseDialogPayload = {
  result: DialogResult;
};
export const closeDialog = createAction(
  '@components/closeDialog',
)<CloseDialogPayload>();

export const afterCloseDialog = createAction(
  '@components/afterCloseDialog',
)<{}>();

export const handleCloseDialog: DialogsHandler<typeof closeDialog> = state =>
  state;

export const handleAfterCloseDialog: DialogsHandler<
  typeof afterCloseDialog
> = state => ({
  ...state,
  dialogs: state.dialogs.slice(1), // remove the first dialog
});

export function* closeDialogSaga(
  params: ActionType<typeof closeDialog>,
): Generator {
  const dialog = (yield select(currentDialogSelector)) as DialogElem;

  if (dialog) {
    yield call(dialog.onResolve, params.payload.result);
    yield put(afterCloseDialog({}));
  } else {
    console.error('Attempting to close a dialog while none exist');
  }
}
